var modal = {
  "adapter-loader.message": "Bestätigen Sie Ihr {{adapter}}-Konto, um fortzufahren",
  "adapter-loader.message1": "Bestätigen Sie Ihr {{adapter}}",
  "adapter-loader.message2": "Konto fortzusetzen",
  "errors-invalid-number-email": "Ungültige E-Mail-Adresse oder Telefonnummer",
  "errors-required": "Erforderlich",
  "external.back": "Zurück",
  "external.connect": "Mit Wallet verbinden",
  "external.title": "Externe Geldbörse",
  "external.walletconnect-connect": "Verbinden",
  "external.walletconnect-copy": "Klicken Sie auf den QR-Code, um ihn in die Zwischenablage zu kopieren",
  "external.walletconnect-subtitle": "Scannen Sie den QR-Code mit einer WalletConnect-kompatiblen Geldbörse",
  "footer.message": "Selbstverwahrungs-Login durch",
  "footer.message-new": "Selbstverwahrungs-Login durch Web3Auth",
  "footer.policy": "Datenschutzrichtlinie",
  "footer.terms": "Nutzungsbedingungen",
  "footer.terms-service": "Nutzungsbedingungen",
  "footer.version": "Versión",
  "header-subtitle": "Wählen Sie eine der folgenden Optionen aus, um fortzufahren",
  "header-subtitle-name": "Ihre {{appName}}-Brieftasche mit einem Klick",
  "header-subtitle-new": "Ihre Blockchain-Brieftasche mit einem Klick",
  "header-title": "Einloggen",
  "header-tooltip-desc": "Die Brieftasche dient als Konto zum Speichern und Verwalten Ihrer digitalen Assets auf der Blockchain.",
  "header-tooltip-title": "Brieftasche",
  "network.add-request": "Diese Website fordert das Hinzufügen eines Netzwerks an",
  "network.cancel": "Abbrechen",
  "network.from": "Von",
  "network.proceed": "Fortfahren",
  "network.switch-request": "Diese Website fordert einen Netzwerkwechsel an",
  "network.to": "Zu",
  "popup.phone-body": "Ihr Ländercode wird automatisch erkannt, aber wenn Sie eine Telefonnummer aus einem anderen Land verwenden, müssen Sie den richtigen Ländercode manuell eingeben.",
  "popup.phone-header": "Telefonnummer und Ländercode",
  "social.continue": "Weitermachen mit",
  "social.continueCustom": "Fahren Sie mit {{adapter}} fort",
  "social.email": "E-Mail",
  "social.email-continue": "Weitermachen mit E-Mail",
  "social.email-new": "name@example.com",
  "social.passwordless-cta": "Weitermachen",
  "social.passwordless-title": "E-Mail oder Telefon",
  "social.phone": "Telefon",
  "social.policy": "Wir speichern keine Daten im Zusammenhang mit Ihren Social Logins.",
  "social.sms": "Mobiltelefon",
  "social.sms-continue": "Mit Mobilgerät fortfahren",
  "social.sms-invalid-number": "Ungültige Telefonnummer",
  "social.sms-placeholder-text": "Z.B.:",
  "social.view-less": "Weniger Optionen anzeigen",
  "social.view-less-new": "Weniger anzeigen",
  "social.view-more": "Weitere Optionen anzeigen",
  "social.view-more-new": "Mehr anzeigen",
  "post-loading.connected": "Sie sind mit Ihrem Konto verbunden",
  "post-loading.something-wrong": "Etwas ist schief gelaufen!"
};
var german = {
  modal: modal
};

export { german as default, modal };
//# sourceMappingURL=german-SYmK-a-e.js.map
